import { Checkbox } from 'src/shared/design-system/Checkbox';
import styled from 'styled-components';

export { Wrapper } from 'src/shared/design-system/Checkbox';

export const Radio = styled(Checkbox).attrs(() => ({ isRadio: true }))``;
